import React, { PureComponent } from 'react';
import { CalculatorAllowedIcon } from './Svgs';
import PopOver from 'chameleon/ui-stack/ui/base/popover';

import './CalculatorAllowedIconButton.scss';

class CalculatorAllowedIconButton extends PureComponent {
  render() {
    // make sure that this text is different than in aria-label
    // if names are same than aeiaDescribedby wouldn't be pronounced during state change
    return (
      <span className="CalculatorAllowedIconButton">
        <span className="sr-only" id="calc_allowed_name">
          Calculator Allowed
        </span>
        <PopOver
          accessibility={{
            'aria-label': 'Calculator&nbsp;Allowed',
            'aria-describedby': 'calc_allowed_name',
          }}
          trigger={<CalculatorAllowedIcon />}
        >
          <span id="calc_allowed">Calculator Allowed</span>
        </PopOver>
      </span>
    );
  }
}

export default CalculatorAllowedIconButton;
